export default __webpack_public_path__ + "static/media/cross-out-address-book.dde6746a.svg";